import { useEffect } from "react";
import ColumbiaHeroSection from "./components/HeroSection";
import ColumbiaStickyNav from "./components/StickyNav";
import ColumbiaProcessingTimeSection from "./components/ProcessingTimeSection";
import ColumbiaServicesSection from "./components/ServicesSection";
import ColumbiaLocalAreaSection from "./components/LocalAreaSection";
import ColumbiaTestimonialsSection from "./components/TestimonialsSection";
import ColumbiaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ColumbiaComparisonSection from "./components/ComparisonSection";
import ColumbiaMistakesSection from "./components/MistakesSection";
import ColumbiaHowItWorksSection from "./components/HowItWorksSection";
import ColumbiaFAQSection, { faqs } from "./components/FAQSection";
import ColumbiaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ColumbiaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function ColumbiaSCPage() {
  useEffect(() => {
    document.title = "Emergency & Expedited Passport Columbia SC | Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/columbia-sc/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Columbia, SC — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Columbia, Lexington, Irmo, West Columbia, and all of the Midlands South Carolina.");
    setMeta("geo.placename", "Columbia, South Carolina");
    setMeta("geo.region", "US-SC");
    setMeta("geo.position", "34.0007;-81.0348");
    setMeta("ICBM", "34.0007, -81.0348");
    setMeta("keywords", "expedited passport Columbia SC, emergency passport Columbia South Carolina, fast passport Midlands SC, passport renewal Columbia");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "South Carolina", item: "https://fastpassportcenter.com/south-carolina/" },
          { "@type": "ListItem", position: 3, name: "Columbia Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Columbia and Midlands South Carolina travelers.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Columbia", containedInPlace: { "@type": "State", name: "South Carolina" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <ColumbiaHeroSection />
      <ColumbiaStickyNav />
      <ColumbiaProcessingTimeSection />
      <ColumbiaServicesSection />
      <ColumbiaLocalAreaSection />
      <ColumbiaTestimonialsSection />
      <ColumbiaAcceptanceFacilitiesSection />
      <ColumbiaComparisonSection />
      <ColumbiaMistakesSection />
      <ColumbiaHowItWorksSection />
      <ColumbiaFAQSection />
      <ColumbiaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/columbia-sc" state="SC" />
      <ColumbiaFinalCTA />
    </div>
  );
}